import { 
    toDDMonFormatAEST,
    toDDMonYearFormatAEST 
} from "../../district/helpers/header-format-date";

export const createButtonTabs = (tableData, printBtnCallback) => {
    const headerContainer = $('#btn-header-container-id');
    
    const buttonTabsContainer = $('<div></div>');
    buttonTabsContainer.css({
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center'
    });
    const updateTimeContainer = $('<div></div>');

    const earliestIssueTime = tableData.summary[0].data.find(
        e => e.issue_time != null);

    updateTimeContainer.text(`Updated at : ${toDDMonYearFormatAEST(earliestIssueTime.issue_time)}`);

    const printBtn = $('<button class="header-btn-style">Print page</button>');
    printBtn.on('click', printBtnCallback);

    // Add the prelimiary text thing
    const prelimDateStr = toDDMonFormatAEST(tableData.summary[0].forecast_start);
    const preliminaryDate = $(`<div class="preliminary-date-style">` + 
            `Preliminary date : ${prelimDateStr}</div>`);
    buttonTabsContainer.append(preliminaryDate);

    // Add the print button tab
    buttonTabsContainer.append(printBtn);

    // Add the button tabs container to the table container
    headerContainer.append(buttonTabsContainer);
    headerContainer.append(updateTimeContainer);
}